<template>
<!-- プロジェクト削除モーダル -->
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
          <CRow>
            <CCol>
              <table class="table">
                <thead>
                  <a style="font-size: 20px"><strong>削除内容確認</strong></a>
                  <CCardText><strong>以下の内容を削除してよろしいですか？</strong></CCardText>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a><strong>顧客会社名</strong></a><br>
                      {{ val.company_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>プロジェクト名</strong></a><br>
                      {{ val.name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>自社管理者</strong></a><br>
                      {{ val.private_staff_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>顧客会社担当者</strong></a><br>
                      {{ val.staff_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>関連会社</strong></a><br>
                      {{ val.related }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他関連</strong></a><br>
                      {{ val.other_related }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>始業時刻</strong></a><br>
                      {{ val.start_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>終業時刻</strong></a><br>
                      {{ val.end_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩開始時間</strong></a><br>
                      {{ val.break_start_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>休憩終了時間</strong></a><br>
                      {{ val.break_end_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>基準時間</strong></a><br>
                      {{ val.base_time }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>契約形態</strong></a><br>
                      {{ val.contract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他契約事項</strong></a><br>
                      {{ val.other_contract }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>開発言語</strong></a><br>
                      {{ val.language }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>その他必要技術</strong></a><br>
                      {{ val.other_tech }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="3">
              <button @click="$emit('close')" class="btn btn-info">キャンセル</button>
            </CCol>
            <CCol sm="3" style="margin: 0 0 0 auto;">
              <save-button
                :label="'削除'"
                :loading="loading"
                class="btn btn-danger"
                @click="$emit('delete')"
              />
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  components: { SaveButton },
  name: 'ProjectDeleteModal',
  data() {
    return {}
  },
  props: {
    val: Object,
    loading: Boolean,
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-height: calc(100vh - 100px);
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: scroll;
}
</style>
